import styled from 'styled-components';

export const FormActions = styled.div`
  button {
    &:not(:last-of-type) {
      margin-right: 18px;
    }
  }
`;
